import m from "./../../../dist/es2015/themes/Adaptive.js";
export const am5themes_Adaptive = m;